<template>
  <div>
    <!-- MonitoreoView -->
  </div>
</template>

<script>
export default {
  name: 'MonitoreoView'
}
</script>



// WEBPACK FOOTER //
// src/views/admin/MonitoreoView.vue